/*=============================================== LoaderPage ===============================================*/

import { Loader, Flexbox } from "tsx-library-julseb"

import { ComponentsLayout } from "components"
import type { ItemType, PropsItemType } from "components"

import { commonProps } from "data"

const LoaderPage = () => {
    const items: ItemType[] = [
        {
            title: "",
            intro: "",
            content: (
                <Flexbox gap="xs" flexWrap="wrap">
                    <Loader variant={1} />
                    <Loader variant={2} />
                    <Loader variant={3} />
                    <Loader variant={4} />
                </Flexbox>
            ),
            code: "<Loader variant={1} />\n<Loader variant={2} />\n<Loader variant={3} />\n<Loader variant={4} />",
        },
    ]

    const propsItems: PropsItemType[] = [
        {
            subtitle: "variant",
            type: "number",
            possible: [1, 2, 3, 4],
            default: 1,
        },
        {
            subtitle: "size",
            type: "number",
            default: 48,
        },
        {
            subtitle: "color",
            type: "string",
            possibleString: commonProps.allColors,
            default: "primary",
        },
        {
            subtitle: "borderWidth",
            intro: (
                <>
                    Only if <code>variant</code> is set to <code>1</code>,{" "}
                    <code>2</code> or <code>3</code>.
                </>
            ),
            type: "number",
            default: 8,
        },
    ]

    return <ComponentsLayout items={items} propsItems={propsItems} />
}

export default LoaderPage
